import server from "../Server";
import withErrorCheck from "../CheckError";

export interface MakePlayerAdminPayload {
  groupId: number;
  playerId: number;
}

export const MakePlayerAdmin = async (payload: MakePlayerAdminPayload): Promise<boolean> => {
  const updateResponse = await server
    .from("GroupPlayers")
    .update({ is_owner: true })
    .eq("group_id", payload.groupId)
    .eq("player_id", payload.playerId);

  withErrorCheck(updateResponse);
  
  return true;
};
